import { Coordinate } from "../../models"
import { blankMap } from "../../util"
import { BaseMapBuilder, MapEntry } from "../base_map_builder"
import { GridCell, HouseBuilder } from "../house/feature/house"

/** Use the same roof artwork and sky triggers as the manual building mechanism. */
export const buildHouseRoof = (cells: Coordinate[], width: number, height: number, roomId: string): MapEntry[] => {
    const blank = () => blankMap<GridCell>(width, height)
    const roof = blank()
    cells.forEach(({ x, y }) => { roof[y][x] = { itemType: "roof-wood" } })
    const builder = new HouseBuilder({} as BaseMapBuilder, {
        blockingTileSpec: { tilePos: 121, tilesetId: "lpc-terrain" },
        house: blank(), roof, entity: blank(), floor: blank(), floor2: blank(), decor: blank(),
    })
    builder.build(roomId)
    return builder.featureSpec.mapEntries.filter(entry => entry.layerId === "sky" || entry.layerId === "skyTrigger")
}
